'use client';

import { useEffect } from 'react';
import ErrorPage from '@/components/shared/ErrorPage';

interface ErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
    useEffect(() => {
        // Log error to console for debugging
        console.error('Application error:', error);
    }, [error]);

    return (
        <div style={{ position: 'relative' }}>
            <ErrorPage
                code={500}
                title="Произошла ошибка"
                message={error.message || 'Что-то пошло не так при загрузке страницы'}
            />
            <div style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 100,
            }}>
                <button
                    onClick={reset}
                    style={{
                        padding: '12px 24px',
                        background: 'var(--cyan)',
                        border: 'none',
                        color: '#000',
                        fontFamily: "'JetBrains Mono', monospace",
                        fontSize: '12px',
                        cursor: 'pointer',
                        fontWeight: 600,
                    }}
                >
                    [ ↻ ПОПРОБОВАТЬ СНОВА ]
                </button>
            </div>
        </div>
    );
}
